import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import GlobalStyles from '@mui/material/GlobalStyles';
import {
  createTheme,
  ThemeProvider,
} from '@mui/material/styles';
import {
  theme as themeDefault,
  hyphenation,
} from '.';
import colors from './colors';

export const executiveColor = colors.black;

export const theme = createTheme({
  ...themeDefault,
  palette: {
    primary: {
      main: executiveColor,
    },
    secondary: {
      main: executiveColor,
    },
  },
  typography: {
    ...themeDefault.typography,
    overline: {
      ...themeDefault.typography.overline,
      color: executiveColor,
    },
  },
});

const globalStyles = (
  <GlobalStyles styles={{
    ':root': {
      ...hyphenation,
      overflowY: 'scroll',
    },
  }}
  />
);

export const themePropertyTypes = {
  children: PropTypes.node,
};

export type ThemeProperties = InferProps<typeof themePropertyTypes>;

export default function ThemeWrapper({ children }: ThemeProperties) {
  return (
    <ThemeProvider theme={theme}>
      {globalStyles}
      {children}
    </ThemeProvider>
  );
}

ThemeWrapper.propTypes = themePropertyTypes;
